var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBytesizeUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8751 41.25C6.81281e-05 43.125 1.87507 22.5 16.8751 24.375C11.2501 3.75 43.1251 3.75 41.2501 18.75C60.0001 13.125 60.0001 43.125 43.1251 41.25M20.6251 33.75L30.0001 26.25M30.0001 26.25L39.3751 33.75M30.0001 26.25V54.375",
    stroke: "#007AFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBytesizeUpload);
export default __webpack_public_path__ + "static/media/bytesize_upload.01cbd6f77a2eb892a214a7ff05b3d8ab.svg";
export { ForwardRef as ReactComponent };